export default "__VITE_ASSET__CXSNouu1__"